import { useSelectApolloQueryData, registerApolloQueryToCache } from '../../../queryData/data/query-data-config';
import { TICKET_FIELD_NAME } from '../../../queryData/data/field-names';
import { getAllRequiredValues } from '../operators/pipelineGetters';
import { fetchTicketForHelpdesk } from '../queries/fetchTicketForHelpdesk';
import { useTicketPipelines } from './useTicketPipelines';
registerApolloQueryToCache({
  fieldName: TICKET_FIELD_NAME,
  query: fetchTicketForHelpdesk
});
export const useTicketFromQueryData = ticketId => {
  const {
    pipelines
  } = useTicketPipelines();
  const {
    data,
    loading,
    error
  } = useSelectApolloQueryData({
    fieldName: TICKET_FIELD_NAME,
    variables: {
      ticketId: ticketId || 1,
      propertyNames: ['subject', 'hs_ticket_category', ...getAllRequiredValues(pipelines)]
    }
  });
  return {
    ticket: data,
    loading,
    error
  };
};